import { useState } from 'react'
import { useEffect } from 'react'

import Dialog from '../../../components/ReusableComponents/Dialog/index'
import brandColors from '../../../main/hotelBrandColors.json'
import { subChains } from '../../../main/hotelBrandsAndChains'
import styles from './ChainLogo.module.scss'

const BASE_LOGO_URL = 'https://cdn.swaypay.io/logos/brands/'

const ChainLogo = ({
  parentChainCode,
  chainCode,
  className,
  brand,
  setBrand,
  setChainCode
}) => {
  const [errored, setErrored] = useState()
  const [subBrands, setSubBrands] = useState([])

  useEffect(() => {
    setBrand(null)
    setSubBrands([])
    setErrored(false)
  }, [parentChainCode, chainCode, setBrand])

  useEffect(() => {
    if (parentChainCode === 'choice' && subChains[chainCode]) {
      setSubBrands(subChains[chainCode])
    } else {
      setBrand(chainCode)
    }
  }, [chainCode, parentChainCode, setBrand, subBrands])

  if (!brand && subBrands.length === 0) {
    return null
  }

  function handleSubBrandClick(subBrand) {
    setBrand(subBrand)
    setChainCode(subBrand)
  }

  return (
    <div
      className={className}
      style={{
        background: brandColors?.[parentChainCode]?.[brand]
          ? brandColors[parentChainCode][brand].primary
          : brandColors.fallback.primary
      }}
    >
      <div className={styles.container}>
        {brand && !errored && (
          <img
            onError={() => setErrored(true)}
            src={BASE_LOGO_URL + brand + '.png'}
            alt={brand}
          />
        )}
        {subBrands.length > 0 && !brand && (
          <Dialog>
            <div
              className={styles.dialog}
              style={{
                background: brandColors?.[parentChainCode]?.[subChains[chainCode][0]]
                  ? brandColors[parentChainCode][subChains[chainCode][0]].primary
                  : brandColors.fallback.primary
              }}
            >
              <div className={styles.dialogTitle}>Select brand logo</div>
              {subBrands.map(s => (
                <button key={s} onClick={() => handleSubBrandClick(s)}>
                  <img src={BASE_LOGO_URL + s + '.png'} alt={s} />
                </button>
              ))}
            </div>
          </Dialog>
        )}
      </div>
    </div>
  )
}

export default ChainLogo
